import NoSleep from 'nosleep.js'

const noSleep = new NoSleep()

const wakeLockAchievers = new Set([])

export const enableNoSleep = (value: string) => {
  if (wakeLockAchievers.has(value)) return
  wakeLockAchievers.add(value)
  checkSleepNess()
}

export const checkSleepNess = () => {
  if (wakeLockAchievers.size > 0) noSleep.enable()
  else noSleep.disable()
}

export const disableNoSleep = (value: string) => {
  if (!wakeLockAchievers.has(value)) return
  wakeLockAchievers.delete(value)
  checkSleepNess()
}
export const disableWappNoSleep = (wappSessionId: string) => {
  wakeLockAchievers.forEach(item => {
    if (item.includes(wappSessionId)) wakeLockAchievers.delete(wappSessionId)
  })
  checkSleepNess()
}
